import ListaEvaporadores from "./ListaEvaporador";
import AlertDialogOnClose from "../../../../components/admin/AlertDiologOnClose";
export default function EvaporadorForm() {
    return (
        <AlertDialogOnClose nome={"Evaporador"} placeholder={"Insira o nome do evaporador"}>
            <ListaEvaporadores/>
        </AlertDialogOnClose>
    )
} 